import React from 'react';
import PropTypes from 'prop-types';
import FlipMove from 'react-flip-move';
import { defaults } from 'lodash';


export default function FlipMoveWrapper({ children, ...props }) {
  const passed = defaults(props, {
    duration: 500,
    easing: 'cubic-bezier(0.190, 1.000, 0.220, 1.000)'
  });

  return (
    <FlipMove {...passed} >{children}</FlipMove>
  );
}

FlipMoveWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  duration: PropTypes.number,
  easing: PropTypes.string
};
